<template>
				
	<!-- Sales By Product Table Card -->
	<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
		<template #title>
			<a-row type="flex" align="middle">
				<a-col :span="24" :md="12">
					<h6>Sales By Product</h6>			
				</a-col>
				<a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
				</a-col>
			</a-row>
		</template>

		<a-table :columns="columns" :showHeader="false" :data-source="dataSource" :pagination="{pageSize: pageSize}">


			<template slot="itemName" slot-scope="itemName">
				<p class="m-0 text-sm font-semibold text-muted">Product Name:</p>
				<h6 class="m-0">{{ itemName }}</h6>
			</template>
            
			<template slot="quanity" slot-scope="quantity">
				<p class="m-0 text-sm font-semibold text-muted">Sales:</p>
				<h6 class="m-0">{{ quantity }}</h6>
			</template>

		</a-table>
	</a-card>
	<!-- / Sales By Country Table Card -->

</template>

<script>

	const tableColumns = [
		
		{
			title: '',
			dataIndex: 'itemName',
			scopedSlots: { customRender: 'itemName' },
			class: "pl-10"
		},
		{
			title: '',
			dataIndex: 'quantity',
			scopedSlots: { customRender: 'quantity' },
		},
		{
			title: '',
			dataIndex: 'value',
			scopedSlots: { customRender: 'value' },
		},
		
	];

	export default ({
		props: {
            dataTable : {type: Array}
		},
		data() {
			return {
				columns: tableColumns,
				dataSource: [],
                pageSize: 5,
			}
		},
        created()  {
            this.dataSource = this.dataTable
        }
	})

</script>